/**
 * <rotating-testimonials>
 *
 * Affiche un avis à la fois, en tourne toutes les X secondes.
 * Animation : l'avis sortant glisse vers la gauche + fade-out,
 * le nouveau apparaît en fondu sur place (pas de slide d'entrée).
 *
 * Data attr :
 *   data-interval  - ms entre deux rotations (>= 2000)
 */
class RotatingTestimonials extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-testimonial]'));
    if (this.items.length <= 1) return; // rien à tourner

    this.index = 0;
    this.interval = Math.max(2000, parseInt(this.dataset.interval || '5000', 10));
    this.transitionMs = 450; // doit correspondre au CSS

    // Pause sur hover (respect des guidelines de motion)
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());

    // Respect prefers-reduced-motion : pas de rotation auto
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    if (this.timer) return;
    this.timer = setInterval(() => this.next(), this.interval);
  }

  stop() {
    if (!this.timer) return;
    clearInterval(this.timer);
    this.timer = null;
  }

  next() {
    const current = this.items[this.index];
    const nextIndex = (this.index + 1) % this.items.length;
    const nextEl = this.items[nextIndex];

    // Trigger leaving animation on current (slide-left + fade-out)
    current.classList.remove('is-active');
    current.classList.add('is-leaving');

    // Activate next simultaneously (fade-in in place)
    nextEl.classList.add('is-active');

    // After transition completes, clean up
    setTimeout(() => {
      current.classList.remove('is-leaving');
    }, this.transitionMs);

    this.index = nextIndex;
  }
}

if (!customElements.get('rotating-testimonials')) {
  customElements.define('rotating-testimonials', RotatingTestimonials);
}
